import { ComponentPropsWithoutRef } from 'react'

export const EditWorkspaceIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.6665 9.58333V4.16667C1.6665 3.72464 1.8421 3.30072 2.15466 2.98816C2.46722 2.67559 2.89114 2.5 3.33317 2.5H6.58317C7.1665 2.5 7.6665 2.75 7.99984 3.25L8.6665 4.25C8.99984 4.75 9.49984 5 10.0832 5H16.6665C17.1085 5 17.5325 5.17559 17.845 5.48816C18.1576 5.80072 18.3332 6.22464 18.3332 6.66667V15C18.3332 15.442 18.1576 15.866 17.845 16.1785C17.5325 16.4911 17.1085 16.6667 16.6665 16.6667H8.74984"
      stroke="#2464F6"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.48165 11.355C9.64602 11.1906 9.77641 10.9955 9.86536 10.7807C9.95432 10.566 10.0001 10.3358 10.0001 10.1033C10.0001 9.87087 9.95432 9.64069 9.86536 9.42593C9.77641 9.21117 9.64602 9.01603 9.48165 8.85166C9.31728 8.68729 9.12214 8.55691 8.90738 8.46795C8.69262 8.37899 8.46244 8.33321 8.22998 8.33321C7.99752 8.33321 7.76734 8.37899 7.55258 8.46795C7.33782 8.55691 7.14268 8.68729 6.97831 8.85166L2.80331 13.0283C2.60519 13.2263 2.46016 13.4711 2.38165 13.74L1.68415 16.1317C1.66323 16.2034 1.66198 16.2794 1.68052 16.3517C1.69905 16.4241 1.7367 16.4901 1.78952 16.543C1.84234 16.5958 1.90838 16.6334 1.98074 16.652C2.0531 16.6705 2.12911 16.6692 2.20081 16.6483L4.59248 15.9508C4.86137 15.8723 5.10613 15.7273 5.30415 15.5292L9.48165 11.355Z"
      stroke="#2464F6"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
